// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  animation: fadeInUp 0.3s ease;
  max-width: 90%;
}
.message.has-error .message-content {
  border-color: #f44336 !important;
}
.message.user-message {
  align-self: flex-end;
  flex-direction: row-reverse;
}
.message.user-message .message-content {
  background: linear-gradient(135deg, #1ab394, #13806a);
  color: #fff;
  border-radius: 18px 18px 4px 18px;
  box-shadow: 0 2px 8px rgba(19, 128, 106, 0.25);
  padding: 10px;
}
.message.user-message .message-avatar {
  background: #1ab394;
}
.message.assistant-message {
  align-self: flex-start;
}
.message.assistant-message .message-content {
  background: #fff;
  color: #333;
  border: 1px solid #e1e5e9;
  border-radius: 18px 18px 18px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.message.assistant-message .message-avatar {
  background: #6c757d;
}
.message.system-message {
  align-self: center;
}
.message.system-message .message-content {
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 18px;
}
.message.system-message .message-avatar {
  background: #adb5bd;
}
.message .message-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.message .message-avatar i {
  color: #fff;
  font-size: 16px;
}
.message .message-content {
  padding: 12px 16px;
  word-wrap: break-word;
  max-width: calc(100% - 48px);
}
.message .message-content .tool-calls-container {
  margin-bottom: 12px;
}
.message .message-content .tool-calls-container .tool-call-accordion {
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
}
.message .message-content .tool-calls-container .tool-call-accordion:last-child {
  margin-bottom: 0;
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-pending {
  border-color: #ff9800;
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-pending .tool-call-header {
  background: rgba(255, 152, 0, 0.1);
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-pending .tool-call-name {
  color: rgb(204, 121.6, 0);
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-success {
  border-color: #4caf50;
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-success .tool-call-header {
  background: rgba(76, 175, 80, 0.1);
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-success .tool-call-name {
  color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-success .fa-check-circle {
  color: #4caf50;
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-error {
  border-color: #f44336;
  border-width: 2px;
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-error .tool-call-header {
  background: rgba(244, 67, 54, 0.1);
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-error .tool-call-name {
  color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.message .message-content .tool-calls-container .tool-call-accordion.tool-call-error .fa-exclamation-circle {
  color: #f44336;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f8f9fa;
  cursor: pointer;
  transition: background 0.2s ease;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header:hover {
  background: rgb(239.075, 241.35, 243.625);
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .tool-call-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .tool-call-info i {
  font-size: 14px;
  color: #666;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .tool-call-info .tool-call-name {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  font-family: "Consolas", "Monaco", monospace;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .tool-call-info .tool-call-status {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #e0e0e0;
  color: #666;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .tool-call-info .tool-call-status.status-success {
  background: rgba(76, 175, 80, 0.2);
  color: rgb(52.8366533865, 121.6633466135, 55.6175298805);
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .tool-call-info .tool-call-status.status-error {
  background: rgba(244, 67, 54, 0.2);
  color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-header .toggle-icon {
  font-size: 12px;
  color: #888;
  transition: transform 0.2s ease;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body {
  padding: 12px;
  background: #ffffff;
  border-top: 1px solid #e1e5e9;
  animation: slideDown 0.2s ease;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section {
  margin-bottom: 12px;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section:last-child {
  margin-bottom: 0;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section .section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section .section-label i {
  font-size: 10px;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section .section-label.error-label {
  color: #f44336;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section .section-content {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 6px;
  font-size: 12px;
  font-family: "Consolas", "Monaco", monospace;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}
.message .message-content .tool-calls-container .tool-call-accordion .tool-call-body .tool-call-section .section-content.error-content {
  background: rgba(244, 67, 54, 0.1);
  color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border: 1px solid rgba(244, 67, 54, 0.3);
}
.message .message-content .message-text {
  margin: 0;
  line-height: 1.5;
  font-size: 14px;
}
.message .message-content .message-text p {
  margin: 0 0 8px;
}
.message .message-content .message-text p:last-child {
  margin-bottom: 0;
}
.message .message-content .message-text pre {
  background: rgba(0, 0, 0, 0.05);
  padding: 8px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 8px 0;
}
.message .message-content .message-text code {
  font-family: monospace;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 4px;
  border-radius: 3px;
}
.message .message-content .message-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  font-size: 12px;
}
.message .message-content .message-footer .message-time {
  color: #888;
}
.message .message-content .message-footer .message-time-user {
  color: white;
}
.message .message-content .message-footer .message-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
}
.message .message-content .message-footer .message-feedback .feedback-button {
  background: none;
  border: none;
  color: #777;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
}
.message .message-content .message-footer .message-feedback .feedback-button:hover:not(.disabled) {
  background: #f0f0f0;
  color: #1ab394;
}
.message .message-content .message-footer .message-feedback .feedback-button.disabled {
  cursor: default;
  color: #1ab394;
  opacity: 0.8;
}
.message .message-content .message-footer .message-feedback .feedback-button:disabled {
  cursor: default;
  color: #1ab394;
  opacity: 0.8;
}
.message .message-content .message-footer .message-feedback .feedback-button i {
  font-size: 14px;
}
.message .message-content .message-footer .streaming-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #888;
  font-size: 12px;
}
.message .message-content .message-footer .streaming-indicator i {
  font-size: 12px;
  color: #1ab394;
}
.message .message-content .loading-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6c757d;
  font-size: 14px;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 500px;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/angularApp/components/wings-assistant-chat/components/wings-message/wings-message.component.scss"],"names":[],"mappings":"AAcA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;AAbF;AAgBI;EACE,gCAAA;AAdN;AAkBE;EACE,oBAAA;EACA,2BAAA;AAhBJ;AAkBI;EACE,qDAAA;EACA,WA7BE;EA8BF,iCAAA;EACA,8CAAA;EACA,aAAA;AAhBN;AAmBI;EACE,mBAvCU;AAsBhB;AAqBE;EACE,sBAAA;AAnBJ;AAqBI;EACE,gBA5CE;EA6CF,WA9CO;EA+CP,yBAAA;EACA,iCAAA;EACA,yCAAA;AAnBN;AAsBI;EACE,mBAAA;AApBN;AAwBE;EACE,kBAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AAtBN;AAyBI;EACE,mBAAA;AAvBN;AA2BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAzBJ;AA2BI;EACE,WAjFE;EAkFF,eAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,qBAAA;EACA,4BAAA;AA3BJ;AA8BI;EACE,mBAAA;AA5BN;AA8BM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA5BR;AA8BQ;EACE,gBAAA;AA5BV;AA+BQ;EACE,qBArGY;AAwEtB;AA+BU;EACE,kCAAA;AA7BZ;AAgCU;EACE,yBAAA;AA9BZ;AAkCQ;EACE,qBAnHY;AAmFtB;AAkCU;EACE,kCAAA;AAhCZ;AAmCU;EACE,wDAAA;AAjCZ;AAoCU;EACE,cA9HU;AA4FtB;AAsCQ;EACE,qBAlIU;EAmIV,iBAAA;AApCV;AAsCU;EACE,kCAAA;AApCZ;AAuCU;EACE,wDAAA;AArCZ;AAwCU;EACE,cA9IQ;AAwGpB;AA0CQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBArJO;EAsJP,eAAA;EACA,gCAAA;AAxCV;AA0CU;EACE,yCAAA;AAxCZ;AA2CU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;AAzCZ;AA2CY;EACE,eAAA;EACA,WAAA;AAzCd;AA4CY;EACE,gBAAA;EACA,eAAA;EACA,WAnLD;EAoLC,4CAAA;AA1Cd;AA6CY;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AA3Cd;AA6Cc;EACE,kCAAA;EACA,wDAAA;AA3ChB;AA8Cc;EACE,kCAAA;EACA,wDAAA;AA5ChB;AAiDU;EACE,eAAA;EACA,WAAA;EACA,+BAAA;AA/CZ;AAmDQ;EACE,aAAA;EACA,mBA1MK;EA2ML,6BAAA;EACA,8BAAA;AAjDV;AAmDU;EACE,mBAAA;AAjDZ;AAmDY;EACE,gBAAA;AAjDd;AAoDY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAlDd;AAoDc;EACE,eAAA;AAlDhB;AAqDc;EACE,cAvOI;AAoLpB;AAuDY;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,4CAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AArDd;AAuDc;EACE,kCAAA;EACA,wDAAA;EACA,wCAAA;AArDhB;AA6DI;EACE,SAAA;EACA,gBAAA;EACA,eAAA;AA3DN;AA8DM;EACE,eAAA;AA5DR;AA6DQ;EACE,gBAAA;AA3DV;AA+DM;EACE,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AA7DR;AAgEM;EACE,sBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AA9DR;AAkEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAhEN;AAkEM;EACE,WAAA;AAhER;AAmEM;EACE,YAAA;AAjER;AAoEM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAlER;AAoEQ;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAlEV;AAoEU;EACE,mBAAA;EACA,cA3UI;AAyQhB;AAqEU;EACE,eAAA;EACA,cAhVI;EAiVJ,YAAA;AAnEZ;AAsEU;EACE,eAAA;EACA,cAtVI;EAuVJ,YAAA;AApEZ;AAuEU;EACE,eAAA;AArEZ;AA0EM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAxER;AA0EQ;EACE,eAAA;EACA,cAzWM;AAiShB;AA6EI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AA3EN;;AAiFA;EACE;IACE,UAAA;IACA,aAAA;EA9EF;EAgFA;IACE,UAAA;IACA,iBAAA;EA9EF;AACF","sourcesContent":["// Variáveis de cores (copiadas do componente pai para evitar import pesado)\n$primary-color: #1ab394;\n$primary-dark: #13806a;\n$text-color: #333;\n$white: #fff;\n\n// Cores para tool calls\n$tool-border-default: #e1e5e9;\n$tool-border-success: #4caf50;\n$tool-border-error: #f44336;\n$tool-border-pending: #ff9800;\n$tool-bg-header: #f8f9fa;\n$tool-bg-body: #ffffff;\n\n.message {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  animation: fadeInUp 0.3s ease;\n  max-width: 90%;\n  \n  &.has-error {\n    .message-content {\n      border-color: $tool-border-error !important;\n    }\n  }\n  \n  &.user-message {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n\n    .message-content {\n      background: linear-gradient(135deg, $primary-color, $primary-dark);\n      color: $white;\n      border-radius: 18px 18px 4px 18px;\n      box-shadow: 0 2px 8px rgba($primary-dark, 0.25);\n      padding: 10px;\n    }\n\n    .message-avatar {\n      background: $primary-color;\n    }\n  }\n\n  &.assistant-message {\n    align-self: flex-start;\n    \n    .message-content {\n      background: $white;\n      color: $text-color;\n      border: 1px solid #e1e5e9;\n      border-radius: 18px 18px 18px 4px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    }\n\n    .message-avatar {\n      background: #6c757d;\n    }\n  }\n\n  &.system-message {\n    align-self: center;\n    \n    .message-content {\n      background: #f8f9fa;\n      color: #6c757d;\n      border: 1px solid #dee2e6;\n      border-radius: 18px;\n    }\n\n    .message-avatar {\n      background: #adb5bd;\n    }\n  }\n\n  .message-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    i {\n      color: $white;\n      font-size: 16px;\n    }\n  }\n\n  .message-content {\n    padding: 12px 16px;\n    word-wrap: break-word;\n    max-width: calc(100% - 48px);\n\n    // Tool Calls Container\n    .tool-calls-container {\n      margin-bottom: 12px;\n      \n      .tool-call-accordion {\n        border: 1px solid $tool-border-default;\n        border-radius: 8px;\n        margin-bottom: 8px;\n        overflow: hidden;\n        transition: all 0.2s ease;\n        \n        &:last-child {\n          margin-bottom: 0;\n        }\n        \n        &.tool-call-pending {\n          border-color: $tool-border-pending;\n          \n          .tool-call-header {\n            background: rgba($tool-border-pending, 0.1);\n          }\n          \n          .tool-call-name {\n            color: darken($tool-border-pending, 10%);\n          }\n        }\n        \n        &.tool-call-success {\n          border-color: $tool-border-success;\n          \n          .tool-call-header {\n            background: rgba($tool-border-success, 0.1);\n          }\n          \n          .tool-call-name {\n            color: darken($tool-border-success, 10%);\n          }\n          \n          .fa-check-circle {\n            color: $tool-border-success;\n          }\n        }\n        \n        &.tool-call-error {\n          border-color: $tool-border-error;\n          border-width: 2px;\n          \n          .tool-call-header {\n            background: rgba($tool-border-error, 0.1);\n          }\n          \n          .tool-call-name {\n            color: darken($tool-border-error, 10%);\n          }\n          \n          .fa-exclamation-circle {\n            color: $tool-border-error;\n          }\n        }\n        \n        .tool-call-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: 10px 12px;\n          background: $tool-bg-header;\n          cursor: pointer;\n          transition: background 0.2s ease;\n          \n          &:hover {\n            background: darken($tool-bg-header, 3%);\n          }\n          \n          .tool-call-info {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            flex: 1;\n            \n            i {\n              font-size: 14px;\n              color: #666;\n            }\n            \n            .tool-call-name {\n              font-weight: 600;\n              font-size: 13px;\n              color: $text-color;\n              font-family: 'Consolas', 'Monaco', monospace;\n            }\n            \n            .tool-call-status {\n              font-size: 11px;\n              padding: 2px 8px;\n              border-radius: 10px;\n              background: #e0e0e0;\n              color: #666;\n              \n              &.status-success {\n                background: rgba($tool-border-success, 0.2);\n                color: darken($tool-border-success, 15%);\n              }\n              \n              &.status-error {\n                background: rgba($tool-border-error, 0.2);\n                color: darken($tool-border-error, 10%);\n              }\n            }\n          }\n          \n          .toggle-icon {\n            font-size: 12px;\n            color: #888;\n            transition: transform 0.2s ease;\n          }\n        }\n        \n        .tool-call-body {\n          padding: 12px;\n          background: $tool-bg-body;\n          border-top: 1px solid $tool-border-default;\n          animation: slideDown 0.2s ease;\n          \n          .tool-call-section {\n            margin-bottom: 12px;\n            \n            &:last-child {\n              margin-bottom: 0;\n            }\n            \n            .section-label {\n              display: flex;\n              align-items: center;\n              gap: 6px;\n              font-size: 11px;\n              font-weight: 600;\n              color: #666;\n              text-transform: uppercase;\n              margin-bottom: 6px;\n              \n              i {\n                font-size: 10px;\n              }\n              \n              &.error-label {\n                color: $tool-border-error;\n              }\n            }\n            \n            .section-content {\n              background: #f5f5f5;\n              padding: 10px;\n              border-radius: 6px;\n              font-size: 12px;\n              font-family: 'Consolas', 'Monaco', monospace;\n              overflow-x: auto;\n              white-space: pre-wrap;\n              word-break: break-word;\n              margin: 0;\n              max-height: 200px;\n              overflow-y: auto;\n              \n              &.error-content {\n                background: rgba($tool-border-error, 0.1);\n                color: darken($tool-border-error, 10%);\n                border: 1px solid rgba($tool-border-error, 0.3);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .message-text {\n      margin: 0;\n      line-height: 1.5;\n      font-size: 14px;\n      \n      // Style for rendered markdown content\n      p {\n        margin: 0 0 8px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n      \n      pre {\n        background: rgba(0, 0, 0, 0.05);\n        padding: 8px;\n        border-radius: 6px;\n        overflow-x: auto;\n        margin: 8px 0;\n      }\n      \n      code {\n        font-family: monospace;\n        background: rgba(0, 0, 0, 0.05);\n        padding: 2px 4px;\n        border-radius: 3px;\n      }\n    }\n\n    .message-footer {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-top: 6px;\n      font-size: 12px;\n      \n      .message-time {\n        color: #888;\n      }\n\n      .message-time-user {\n        color: white;\n      }\n      \n      .message-feedback {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        \n        .feedback-button {\n          background: none;\n          border: none;\n          color: #777;\n          font-size: 12px;\n          padding: 4px 8px;\n          border-radius: 12px;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          transition: all 0.2s ease;\n          \n          &:hover:not(.disabled) {\n            background: #f0f0f0;\n            color: $primary-color;\n          }\n          \n          &.disabled {\n            cursor: default;\n            color: $primary-color;\n            opacity: 0.8;\n          }\n          \n          &:disabled {\n            cursor: default;\n            color: $primary-color;\n            opacity: 0.8;\n          }\n          \n          i {\n            font-size: 14px;\n          }\n        }\n      }\n      \n      .streaming-indicator {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        color: #888;\n        font-size: 12px;\n        \n        i {\n          font-size: 12px;\n          color: $primary-color;\n        }\n      }\n    }\n    \n    .loading-indicator {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #6c757d;\n      font-size: 14px;\n    }\n  }\n}\n\n// Animação para o accordion\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 500px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
